import React, { useEffect, useState ,useMemo } from 'react';
import '../styles.css';
import 'flatpickr/dist/flatpickr.min.css';
import Sidebar from './Sidebar';
import { API_BASE_URL } from '../config';
import { Session } from "./utils/session";

   const SHEET_NAME_MAP = {
    PEERS: 'Allocation_Sheet_PEERS_2025',
    PHADS: 'daily_report_sheet_December_PHAD',
    IME: 'IME Sheet 2026',
  };

export default function GoogleSheet() {
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [sheetId, setSheetId] = useState(null);
  const [selectedSource, setSelectedSource] = useState('');
  const [sheetTabs, setSheetTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState('');
  const [zoom, setZoom] = useState(1); // 1 = 100%

  const zoomIn = () => {
  setZoom((prev) => Math.min(prev + 0.1, 2)); // max 200%
};

const zoomOut = () => {
  setZoom((prev) => Math.max(prev - 0.1, 0.5)); // min 50%
};


useEffect(() => {
  const savedSource = sessionStorage.getItem('gs_selectedSource');
  const savedSheetId = sessionStorage.getItem('gs_sheetId');
  const savedTab = sessionStorage.getItem('gs_selectedTab');

  if (savedSource) setSelectedSource(savedSource);
  if (savedSheetId) setSheetId(savedSheetId);
  if (savedTab) setSelectedTab(JSON.parse(savedTab));
}, []);

  const workspaces = Session.getWorkspacesName();
  const role = Session.getRole();
  console.log("User Role:", role);
  console.log("User Workspaces:", workspaces);

  const SHEET_OPTIONS = [
    { value: 'PEERS', label: 'PEERS' },
    { value: 'PHADS', label: 'PHADS' },
    { value: 'IME', label: 'IME' },
  ];

  const normalize = v => (v || '').toString().toLowerCase().trim();
  const roleNorm = normalize(role);

  const matchesWorkspace = (optValue) => {
    if (!workspaces) return false;
    if (Array.isArray(workspaces)) {
      return workspaces.map(w => normalize(w)).includes(normalize(optValue));
    }
    if (typeof workspaces === 'object') {
      try {
        const values = Object.values(workspaces).map(v => normalize(v));
        return values.includes(normalize(optValue));
      } catch (e) {
        return false;
      }
    }
    return normalize(workspaces) === normalize(optValue);
  };

  let allowedOptions = SHEET_OPTIONS;
  let selectDisabled = false;
  if (roleNorm === 'team leader' || roleNorm === 'teamleader' || roleNorm === 'team_leader') {
    allowedOptions = SHEET_OPTIONS.filter(o => matchesWorkspace(o.value));
  } else if (roleNorm === 'member') {
    allowedOptions = SHEET_OPTIONS;
    selectDisabled = true;
  } else {
    allowedOptions = SHEET_OPTIONS;
  }

const fetchSheetTabs = async (token, spreadsheetId) => {
  const res = await fetch(
    `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const data = await res.json();

  const tabs = (data.sheets || []).map((s) => ({
    title: s.properties.title,
    gid: s.properties.sheetId,
  }));

  setSheetTabs(tabs);

  const savedTab = sessionStorage.getItem('gs_selectedTab');
  if (savedTab) {
    const parsedTab = JSON.parse(savedTab);
    const match = tabs.find(t => t.gid === parsedTab.gid);
    if (match) {
      setSelectedTab(match);
      return;
    }
  }

  if (tabs.length > 0) {
    setSelectedTab(tabs[0]);
  }
};


  useEffect(() => {
    if (!selectedSource) return;
    const allowedVals = (allowedOptions || []).map(o => o.value);
    if (!allowedVals.includes(selectedSource)) {
      setSelectedSource('');
      setSheetId(null);
      setSheetTabs([]);
      setSelectedTab(null);
    }
  }, [selectedSource, role, workspaces]);


  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile'); else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop'); else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width'); else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar(s => !s);
    } else {
      setHideDesktop(s => !s);
    }
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) setShowMobileSidebar(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem('google_access_token');
    if (token) {
      setAccessToken(token);
    }
  }, []);

 const signInWithGoogle = (source) => {

  window.google.accounts.oauth2
    .initTokenClient({
      client_id:
        '251591668926-kon8qbuu2g381smt60tc7t9g4auu8amn.apps.googleusercontent.com',
      scope:
        'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets.readonly',
      prompt: '',
      callback: async tokenResponse => {

        try {

          const token = tokenResponse.access_token;
          sessionStorage.setItem("google_access_token", token);
          setAccessToken(token);

          const sheetName = SHEET_NAME_MAP[source];

          const id = await getSheetIdByName(token, sheetName);

          if (!id) {
            alert("Sheet not found in your Google Drive");
            return;
          }

          setSheetId(id);
          sessionStorage.setItem('gs_sheetId', id);

          await fetchSheetTabs(token, id);

        } catch (err) {

          console.error("Google Sheet Error:", err);

          alert("Sheet not found .");

          setSheetId(null);
          setSheetTabs([]);
          setSelectedTab(null);
        }
      },
    })
    .requestAccessToken();
};

  const isBlank = v => v === null || v === undefined || String(v).trim() === '';
  const colIndexToLetter = index => {
    let s = '';
    let n = index + 1;
    while (n > 0) {
      let m = (n - 1) % 26;
      s = String.fromCharCode(65 + m) + s;
      n = Math.floor((n - 1) / 26);
    }
    return s;
  };

  const getSheetIdByName = async (token, sheetName) => {
    const query = encodeURIComponent(
      `name='${sheetName}' and mimeType='application/vnd.google-apps.spreadsheet'`
    );
    const res = await fetch(
      `https://www.googleapis.com/drive/v3/files?q=${query}&fields=files(id,name)`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await res.json();
    if (!data.files || data.files.length === 0) {
      throw new Error(`Sheet not found: ${sheetName}`);
    }
    return data.files[0].id;
  };

  const saveToServer = async () => {
    if (!selectedTab) {
      alert('Please select a Sheet Tab');
      return;
    }
    console.log('Selected Tab:', selectedTab);
    try {
      if (!accessToken) {
        alert('Please login with Google first');
        return;
      }

      const confirmSave = window.confirm(
        `Are you sure to update Tasks for :\n"${selectedTab.title}" ?`
      );

      if (!confirmSave) {
        return;
      }
      const RANGE = `'${selectedTab.title}'!A1:Z`;
      const SHEET_ID = sheetId;
      const sheetUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}`;

      const res = await fetch(sheetUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const sheetData = await res.json();
      if (!sheetData.values || sheetData.values.length === 0) {
        alert('Sheet is empty');
        return;
      }
      const latest = sheetData.values;
      const usedColumnIndexes = (latest[0] || [])
        .map((_, i) => i)
        .filter(i => latest.some(row => !isBlank(row[i])));
      const excelData = latest
        .map((row, rowIndex) => {
          const obj = {};
          usedColumnIndexes.forEach(colIndex => {
            const cell = row[colIndex];
            if (!isBlank(cell)) {
              const key = `${colIndexToLetter(colIndex)}${rowIndex + 1}`;
              obj[key] = cell;
            }
          });
          return obj;
        })
        .filter(obj => Object.keys(obj).length > 0);

      const payload = {
        SheetData: JSON.stringify(excelData),
        SheetType: selectedSource,
        UserId: Session.getUserId(),
        TabName: selectedTab.title
      };
      console.log('Payload:', payload);
      const appToken = Session.getToken();
      const headers = {
        'Content-Type': 'application/json',
      };
      if (appToken) headers['Authorization'] = `Bearer ${appToken}`;
      if (accessToken) headers['X-Google-Access-Token'] = accessToken;
      headers['X-Call-Time'] = new Date().toISOString();

      const resp = await fetch(
        `${API_BASE_URL}/api/LiveFeedExcel/GoogleSaveExcelData`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify(payload),
        }
      );
      if (!resp.ok) throw new Error(await resp.text());
      alert('✅ Google Sheet data saved successfully');
     
    } catch (err) {
      alert('❌ Error: ' + err.message);
    }
  };

  useEffect(() => {
    if (!accessToken || !selectedSource) return;

    const sheetName = SHEET_NAME_MAP[selectedSource];
    getSheetIdByName(accessToken, sheetName)
      .then(id => {
        setSheetId(id);
        fetchSheetTabs(accessToken, id).catch(err => console.error(err));
      })
      .catch(err => console.error(err));
  }, [selectedSource, accessToken]);


  return (
    <div>
      <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      <div id="sidebar">
        <Sidebar />
      </div>
      <div id="content">
        <div className="d-flex align-items-center mb-3 justify-content-between">
          <div>
            <button className="btn btn-toggle me-3" onClick={toggleSidebar}>
              <i className="fas fa-bars" />
            </button>

            <a href="/" className="text-muted text-decoration-none small me-2">
              <i className="fas fa-chevron-left" /> Back
            </a>
          </div>

          <div className="buttonsDiv d-flex align-items-center gap-2">
            <label className="fw-semibold me-2">Zoom:</label>
            <button className="btn btn-outline-secondary" onClick={zoomOut}>-</button>

            <span style={{ minWidth: '60px', textAlign: 'center' }}>
              {Math.round(zoom * 100)}%
            </span>

            <button className="btn btn-outline-secondary" onClick={zoomIn}>+</button>
            <br />
            <label className="fw-semibold me-2">Google Sheet:</label>

            <select
              className="form-select"
              style={{ width: '120px' }}
              value={selectedSource}
              onChange={(e) => {
                const source = e.target.value;
                setSelectedSource(source);
                sessionStorage.setItem('gs_selectedSource', source);
                if (source === '') {
                  setSheetId(null);
                  setSheetTabs([]);
                  setSelectedTab(null);
                  return;
                }

                signInWithGoogle(source);
              }}
              disabled={selectDisabled}
            >
              <option value="" className="text-danger">Select</option>
              {allowedOptions && allowedOptions.length === 0 ? (
                <option value="">No options available</option>
              ) : (
                allowedOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))
              )}
            </select>

            {sheetTabs.length > 0 && (
              <>
                <select
                  className="form-select"
                  style={{ width: '220px' }}
                  value={selectedTab?.gid || ''}
                  onChange={(e) => {
                    const gid = Number(e.target.value);
                    const tab = sheetTabs.find(t => t.gid === gid);
                    setSelectedTab(tab);
                     sessionStorage.setItem('gs_selectedTab', JSON.stringify(tab));
                  }}
                >
                  <option value="" className="text-danger">
                    Select Sheet Tab
                  </option>

                  {sheetTabs.map((tab) => (
                    <option key={tab.gid} value={tab.gid}>
                      {tab.title}
                    </option>
                  ))}
                </select>
                <button
                  className="btn btn-primary"
                  onClick={saveToServer}
                >
                  Save To Task
                </button>
              </>
            )}
          </div>

        </div>
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          {sheetId && selectedTab && (
            <div
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: 'top left',
                width: `${100 / zoom}%`,
                height: `${100 / zoom}%`
              }}
            >
              <iframe
                title="Google Sheet"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                src={`https://docs.google.com/spreadsheets/d/${sheetId}/edit#gid=${selectedTab.gid}`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
